import React, { Component, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export default class Badge extends Component<Props> {
  render () {
    return (
      <div className="flex bg-white px-2 py-1 gap-1.5 rounded border border-gray-300 relative z-50">
        {this.props.children}
      </div>
    )
  }
}
